import { Link as UiLink, TableCell } from '@mui/material';
import { Link } from 'react-router-dom';
import {
  AdminPaginatedList,
  AdminPage,
  AdminTableRow,
} from '@deloitte-us-consulting-dd/blueprint-ux-admin';

const BenchmarkSubSectorsList = () => {
  return (
    <AdminPage
      animation={true}
      title='Sub Sectors'
      newAction='/benchmarks/sub-sectors/new'
    >
      <AdminPaginatedList
        columns={['name', 'url', 'actions']}
        url='/admin/benchmarks/sub-sectors'
        itemTemplate={itemTemplate}
        filterKeys={[]}
      />
    </AdminPage>
  );
};

const itemTemplate = ({ id, name, url }, index) => (
  <AdminTableRow key={index}>
    <TableCell>
      <UiLink component={Link} to={`/benchmarks/sub-sectors/${id}`}>
        {name}
      </UiLink>
    </TableCell>
    <TableCell>{url}</TableCell>
    <TableCell>
      <UiLink component={Link} to={`/benchmarks/sub-sectors/${id}`}>
        View
      </UiLink>
    </TableCell>
  </AdminTableRow>
);

export default BenchmarkSubSectorsList;
